import { DailyBillingSettingAPI } from "../api";
import { AccountingProduct } from "../classes"
export class DailyBillingSetting {
  constructor(data) {
    for (const [key, value] of Object.entries(data)) {
      this[key] = value;
    }
    this.typeString = ""
    if (data.type == "daily") {
      this.typeString = "ต่อวัน"
    } else if (data.type == "booking") {
      this.typeString = "ต่อการจอง"
    } else if (data.type == "daily_square_metre") {
      this.typeString = "คิดตามตารางเมตร ต่อวัน"
    } else if (data.type == "booking_square_metre") {
      this.typeString = "คิดตามตารางเมตร ต่อการจอง"
    }
    this.accountingProduct = new AccountingProduct(data.accountingProduct)
  }
  static async getDailyBillingSettingsByAreas(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByAreas(payload);
    return data.result.map((item) => new DailyBillingSetting(item));
  }
  static async getDailyBillingSettingsByIncludeArea(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByIncludeArea(payload);
    data.result.map((item) => new DailyBillingSetting(item));
    return data.result;
  }
  static async getDailyBillingSettingsByMeters(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByMeters(payload);

    return data.result.map((item) => new DailyBillingSetting(item));
  }
  static async getDailyBillingSettings(payload) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettings(payload);
    return data.result.map(item => (item = new DailyBillingSetting(item)));
  }
  static async createDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.createDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async removeDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.removeDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async removeDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.removeDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async updateDailyBillingSetting(payload) {
    const { data } = await DailyBillingSettingAPI.updateDailyBillingSetting(payload);
    let billingSetting = new DailyBillingSetting(data.result);
    return billingSetting
  }
  static async getDailyBillingSettingsByIds(ids) {
    const { data } = await DailyBillingSettingAPI.getDailyBillingSettingsByIds(ids);
    return data.result.map(item => (item = new DailyBillingSetting(item)));
  }
}
